<script>
  import Modal from '@components/general/modal.svelte'
  import Image from '@components/general/image.svelte'
  import Button from '@components/buttons/button.svelte'
  import Form from '@components/forms'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, Trash2, CirclePlus, Globe } from 'lucide-svelte'

  let { contributor, open = $bindable(false), onClose, onSuccess } = $props()

  let title = $derived(contributor?.name || "Contributor")

  let isUpdate = $derived(contributor?.id)

  const form = $derived(useForm({
    name: contributor?.name || '',
    role: contributor?.role || '',
    bio: contributor?.bio?.html || '',
    image: null,
  }))

  function deleteImage() {
    if (!window.confirm("Are you sure you want to delete this image?")) return
    router.delete(`/admin/contributors/${contributor.id}/delete_image`, {
      onSuccess: () => {
        contributor.image = null
        $form.image = null
      }
    })
  }
  
  function handleSuccess() {
    onSuccess?.()
    open = false
  }

  function handleCreate() {
    $form.transform((data) => {
      const payload = { ...data }
      if (!(payload.image instanceof File)) delete payload.image
      return { contributor: payload }
    })
    $form.post('/admin/contributors', { onSuccess: handleSuccess, forceFormData: true })
  }

  function handleUpdate() {
    $form.transform((data) => {
      const payload = { ...data }
      if (!(payload.image instanceof File)) delete payload.image
      return { contributor: payload }
    })
    $form.put(`/admin/contributors/${contributor.id}`, { onSuccess: handleSuccess, forceFormData: true })
  }

  function handleSubmit(e) {
    e.preventDefault()
    isUpdate ? handleUpdate() : handleCreate()
  }

  function handleClose() {
    onClose?.()
    $form.reset()
  }

</script>

<Modal bind:open {title} onClose={handleClose}>


  <Form.Element {form} id="new-contributor-form" onsubmit={handleSubmit}>
    
    <Form.Items>
      
      <!-- The name -->
      <Form.Item name="name" bind:value={$form.name} label="Name" hint="The name of the contributor" cols={6} required />
      
      <!-- The role -->
      <Form.Item name="role" bind:value={$form.role} label="Role" hint="The role of the contributor" cols={6} />
      
      <!-- The image -->
      {#if contributor?.image}
        <Form.Item name="image" label="Image">
          <div class="flex flex-col items-start gap-2">
            <Image src={contributor.image} alt={contributor.name} loading="lazy" class="size-16 border border-gray-200/70 bg-gray-100 rounded-full" />
            <Button variant="naked" Icon={Trash2} text="Delete this image" onclick={deleteImage} class="text-gray-500" />
          </div>
        </Form.Item>
      {:else}
        <Form.Item name="image" label="Image" hint="The image of the contributor" type="file" cols={12} accept="image/*"
          oninput={e => $form.image = e.target.files[0]} />
      {/if}
        
      <!-- The bio text -->
      <Form.Item name="bio" bind:value={$form.bio} label="Bio" hint="The bio of the contributor" cols={12} type="richtext" />

    </Form.Items>

  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="new-contributor-form" variant="submit" loading={$form.processing}
      text={isUpdate ? "Update contributor" : "Create contributor"}
      Icon={isUpdate ? Save : CirclePlus}
     />

    {#if isUpdate}
      <Button path={`/contributors/${contributor.id}`} Icon={Globe} />
    {/if}
  {/snippet}

</Modal>